const CHANNELS = ["YouTube", "Newsletters", "Podcasts", "LinkedIn", "Instagram", "TikTok"];
const STEPS = ["Discovery", "Outreach", "Negotiation", "Activation", "Tracking", "Optimization", "Reporting"];

const Chip = ({ children, dark = false }) => (
    <span
        className={`inline-flex items-center rounded-full px-2.5 h-7 text-[11.5px] font-semibold whitespace-nowrap ${
            dark
                ? "bg-[#0A0A0A] text-white"
                : "bg-white border border-black/[0.08] text-[#0A0A0A]"
        }`}
    >
        {children}
    </span>
);

const MultiChannel = () => (
    <div data-testid="diagram-multi-channel" className="flex items-center gap-3 md:gap-4">
        <div className="flex flex-wrap gap-1.5 max-w-[240px]">
            {CHANNELS.map((c) => (
                <Chip key={c}>{c}</Chip>
            ))}
        </div>
        <svg viewBox="0 0 48 60" className="h-14 w-10 flex-none" fill="none" aria-hidden="true">
            <path d="M2 6 C 24 6, 24 30, 46 30 M2 30 L46 30 M2 54 C 24 54, 24 30, 46 30" stroke="#D4D4D4" strokeWidth="1.5" />
            <circle cx="46" cy="30" r="3" fill="#0A0A0A" />
        </svg>
        <Chip dark>Relevant audiences</Chip>
    </div>
);

const MicroMacro = () => (
    <div data-testid="diagram-micro-macro">
        <svg viewBox="0 0 320 90" className="w-full h-auto" fill="none" aria-hidden="true">
            <path d="M8 78 C 70 76, 110 70, 160 56 S 250 24, 312 10" stroke="#D4D4D4" strokeWidth="1.5" strokeLinecap="round" />
            {[18, 40, 62, 84, 106, 128].map((x, i) => (
                <circle key={x} cx={x} cy={78 - i * 3.2} r="3" fill="#0A0A0A" opacity={0.5 + i * 0.08} />
            ))}
            <circle cx="176" cy="51" r="4.5" fill="#0A0A0A" />
            <circle cx="222" cy="36" r="6.5" fill="#0A0A0A" />
            <circle cx="276" cy="19" r="9" fill="#0A0A0A" />
            <circle cx="276" cy="19" r="4" fill="#C6F432" />
        </svg>
        <div className="mt-2 flex items-center justify-between text-[11px] font-semibold text-gray-500">
            <span>Micro: test, learn, volume</span>
            <span>Macro: reach, authority</span>
        </div>
    </div>
);

const AeoGeo = () => (
    <div data-testid="diagram-aeo-geo" className="flex items-center gap-3 md:gap-4">
        <div className="flex flex-col gap-1.5">
            <Chip>Creator video</Chip>
            <Chip>Social media mentions</Chip>
            <Chip>Podcast episode</Chip>
        </div>
        <svg viewBox="0 0 48 60" className="h-14 w-10 flex-none" fill="none" aria-hidden="true">
            <path d="M2 6 C 24 6, 24 30, 46 30 M2 30 L46 30 M2 54 C 24 54, 24 30, 46 30" stroke="#D4D4D4" strokeWidth="1.5" />
            <circle cx="46" cy="30" r="3" fill="#0A0A0A" />
        </svg>
        <div className="flex flex-col gap-1.5">
            <Chip dark>Brand authority</Chip>
            <Chip dark>AI search discovery</Chip>
        </div>
    </div>
);

const Execution = () => (
    <div data-testid="diagram-execution" className="flex flex-wrap items-center gap-y-2">
        {STEPS.map((s, i) => (
            <div key={s} className="flex items-center">
                <Chip dark={i === STEPS.length - 1}>{s}</Chip>
                {i < STEPS.length - 1 && <span className="mx-1.5 h-px w-3 bg-gray-300" />}
            </div>
        ))}
    </div>
);

const MAP = {
    "multi-channel": MultiChannel,
    "micro-macro": MicroMacro,
    "aeo-geo": AeoGeo,
    execution: Execution,
};

export const ServiceDiagram = ({ id }) => {
    const Comp = MAP[id];
    return Comp ? <Comp /> : null;
};

export default ServiceDiagram;
